// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createAutoDelivery as createAutoDeliveryService,
    CreateAutoDeliveryDtoModel,
} from "@guestsupply/App/Services/AutoDelivery";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export type AutoDeliveryProps = {
    productId: string;
};
type HandlerType = ApiHandler<
    CreateAutoDeliveryDtoModel & HasOnSuccess & HasOnError<string>,
    ServiceResult<CreateAutoDeliveryDtoModel> & {
        errorMessage?: string;
    }
>;

export const CallCreateAutoDeliveryApi: HandlerType = async props => {
    const {
        productId,
        shipToId,
        carrierId,
        shipViaId,
        purchaseOrderNo,
        qty,
        uom,
        startDate,
        repetition,
        contactEmail,
    } = props.parameter;

    const createAutoDelivryResult = await createAutoDeliveryService({
        productId,
        shipToId,
        carrierId,
        shipViaId,
        purchaseOrderNo,
        qty,
        uom,
        startDate,
        repetition,
        contactEmail,
    });
    props.apiResult = createAutoDelivryResult;
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};
export const chain = [CallCreateAutoDeliveryApi, ExecuteOnSuccessCallback];

const createAutoDelivery = createHandlerChainRunner(chain, "createAutoDelivery");
export default createAutoDelivery;
